import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useEffect, useRef, useState } from 'react'
import { Box, Error, Label } from 'shared/ui'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { SendFrom } from 'widgets/SendFrom'
import { TagsDropdown } from 'widgets/TagsDropdown'
import { useWidgetChatContext } from 'pages/settings/pages/widgetChat/context/widgetChatContext'
import { WidgetChatCard } from 'pages/settings/pages/widgetChat/ui/WidgetChatCard'
import styles from './styles.module.scss'

export const ConversationsBlock = observer(() => {
  const { conversationsBlockStore, customizeBlockStore, setIsChatVisible } = useWidgetChatContext()
  const { sendFromStore, tagsControlStore } = conversationsBlockStore
  const containerRef = useRef<HTMLDivElement>(null)
  const [containerWidth, setContainerWidth] = useState<number | undefined>(undefined)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (entry) {
        setContainerWidth(entry.contentRect.width)
      }
    })

    resizeObserver.observe(el)
    setContainerWidth(el.getBoundingClientRect().width)

    return () => resizeObserver.disconnect()
  }, [])

  const width = containerWidth !== undefined && containerWidth > 0 ? containerWidth : undefined

  return (
    <>
      <WidgetChatCard
        blockId='2'
        title='Conversations'
        description='Choose the inbox that will receive submitted messages. You can optionally apply tags to these contacts.'
      />
      <Box ref={containerRef} display='flex' flexDirection='column' gap={'24px'} marginTop={'8px'}>
        <div>
          <Label label={{ text: 'Assign inbox' }} marginBottom={4} />
          <SendFrom
            store={sendFromStore}
            triggerVariant={'textField'}
            contentOffset={[4, 4]}
            showActiveIcon
            onClearError={customizeBlockStore.clearAssignInboxError}
            textFiledTriggerProps={{
              error: {
                showIcon: false,
                message: customizeBlockStore.assignInboxError ?? undefined,
              },
              rightActions: [makeTextFieldIcon({ icon: 'chevronDown', fontSize: 18 })],
              textFieldPlaceholderProps: {
                size: 'medium',
                className: classNames(
                  styles.selectTrigger,
                  styles.assignInboxTrigger,
                  customizeBlockStore.assignInboxError && styles.selectTrigger_assignInboxError
                ),
                onClick: () => setIsChatVisible(true),
              },
            }}
            width={width}
          />
          {customizeBlockStore.assignInboxError && (
            <Error
              type='text'
              error={customizeBlockStore.assignInboxError}
              size='small'
              wrapClassName={styles.assignInboxError}
            />
          )}
        </div>
        <div>
          <Label label={{ text: 'Apply tags', secondaryText: '(optional)' }} marginBottom={4} />
          <div className={styles.selectTrigger}>
            <TagsDropdown
              controlStore={tagsControlStore}
              placeholder='Select tags'
              showContactsCount={false}
              triggerStyle='textField'
              width={width}
            />
          </div>
        </div>
      </Box>
    </>
  )
})
